export default __webpack_public_path__ + "static/media/master_copy_icon.c8af3c62.svg";